import React from 'react';
import clsx from 'clsx';

import { type FieldProps } from '@/stories/components/Form/Input/Input';
import { Icon, type IconType } from '@/stories/atoms/Icon/Icon';
import { FormItem } from '@/stories/components/Form/FormItem/FormItem';
import styles from './type-biens.module.css'
import { Count } from '@/stories/atoms/Count/Count';

export type CheckboxProps = React.ComponentProps<'input'> & Omit<FieldProps, "label"> & {
  label?: string | React.ReactElement,
  icon?: IconType,
  count?: number
}

export const TypeBien = ({label, icon, id, value, count, required = false, variant, className, ...props}: CheckboxProps) => {

  return (
    <FormItem id={id} className={className} inline>
      <label htmlFor={id} className={clsx(styles.label, variant && styles[variant], count === 0 && styles.disabled)}>
        <input type='checkbox' id={id} value={value} {...props} required={required}/>
        {icon ? <Icon icon={icon} size={'2xl'}/> : null}
        {label}
        {count ? <Count value={count}/> :null}
      </label>
    </FormItem>
  )
};
